import { createApp } from 'vue'
import store from 'store'

import CheckoutCart from './CheckoutCart.vue'

const el = '.nti-component--checkout-cart'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(CheckoutCart)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}